var _script, _link, _path, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    id: "argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7582 -3.97364e-07H14.6238C14.2851 -3.97364e-07 14.0138 0.281178 14.0064 0.630683C13.8017 10.4549 8.82234 19.7792 0.251893 26.3837C-0.0202046 26.5933 -0.0821946 26.9872 0.116734 27.2709L6.04623 35.734C6.24796 36.022 6.64099 36.087 6.91766 35.8754C12.2765 31.7728 16.5869 26.8236 19.691 21.338C22.7951 26.8236 27.1057 31.7728 32.4646 35.8754C32.741 36.087 33.1341 36.022 33.3361 35.734L39.2656 27.2709C39.4642 26.9872 39.4022 26.5933 39.1304 26.3837C30.5597 19.7792 25.5804 10.4549 25.3759 0.630683C25.3685 0.281178 25.0969 -3.97364e-07 24.7582 -3.97364e-07Z",
    fill: "#FF875B"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    id: "dark-mode-custom-color"
  }, "\n\t\t:root{\n\t\t\t--bg-color:rgba(26,26,26,1);\n\t\t\t--text-color:rgba(255,255,255,1);\n\t\t\t--a-color:rgba(90,120,120,1);\n\t\t\t--a-visited-color:rgba(120,120,90,1);\n\t\t\t--a-hover-color:rgba(211,211,211,1);\n\t\t\t--input-border-color:rgba(211,211,211,0.2);\n\t\t\t--input-placeholder-color:rgba(173,216,230,1);\n\t\t\t--dialog-bg-color:rgba(36,36,36,0.95);\n\t\t\t--bg-image:linear-gradient(rgba(26,26,26,1),rgba(26,26,26,1));\n\t\t}\n\t")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgent);
export default __webpack_public_path__ + "static/media/argent.e2eead394e28cbcbbd1bc8f709cc335a.svg";
export { ForwardRef as ReactComponent };